import React from 'react';
import styled, {css} from 'styled-components';
import presets from "../utils/presets";
import {rhythm} from "../utils/typography";

import Background from "../com/Background";

const BackgroundMobile = Background.extend`
@media (min-device-width:416px) and (orientation: portrait){
  display:none;
}
`

export default BackgroundMobile



// WEBPACK FOOTER //
// ./src/com/BackgroundMobile.js